import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import getColumns from "./columns";
import CreateClientModal from "components/create_modals/CreateClientModal";
import { useAuth } from "context/providers/auth";

const ClientsList = () => {
  const {
    state: {
      user: { clients_index_columns },
    },
    updateUserClientsIndexColumns,
  } = useAuth();
  
  const columns_data = getColumns(clients_index_columns);

  return (
    <MainLayout
      breadcrumbs={[{ name: "Klienci" }]}
      buttons={<CreateClientModal />}
    >
      <MainList
        columns={columns_data}
        query_name="clients"
        query_path="/clients"
        query_context="index"
        show_checklist={true}
        checked_list={clients_index_columns}
        updateCheckedList={updateUserClientsIndexColumns}
      />
    </MainLayout>
  );
};
export default ClientsList;
